import { render, staticRenderFns } from "./production-fields.vue?vue&type=template&id=3fc84fb4&"
import script from "./production-fields.vue?vue&type=script&lang=js&"
export * from "./production-fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports